export { LegendHeader } from './LegendHeader.component';
